import { Box } from '@mui/material';
import CoverageCheckbox from '../../../../../../agencies/quotes/PrimeX/customizeQuote/components/CoverageCheckbox';

export const CoverageLegend = () => {
  return (
    <Box
      style={{
        display: 'flex',
        alignItems: 'center',
        paddingTop: 0,
      }}
    >
      <CoverageCheckbox.Mandatory />
      <CoverageCheckbox.Selected disabled />
      <CoverageCheckbox.Available disabled />
      <CoverageCheckbox.NotAvailable />
    </Box>
  );
};
